import React, {Component} from 'react';
import {gpn} from "../GPN"
import Button from "../sections/MUI/Button";
import Back from "../sections/Back";
import axios from "axios";
import config from "../config";
import Field from "../sections/MUI/Field";
import File from "../sections/MUI/File";
import Modal from "../sections/MUI/Modal";
import {toast} from "react-toastify";
import Icon from "../sections/MUI/Icon";

class Experts extends Component {

    state = {
        experts: [],
        servicesList: [],
        boxAdd: false,

        firstName: "",
        lastName: "",
        phoneNumber: "",
        image: null,
        chatId: "",
        services: [],
        modalServices: false
    };

    componentDidMount() {
        config.scrollTop();
        this.getServices();
        this.getExpert();
    }

    getExpert() {
        axios.get(`${config.api}/admin/experts?token=${config.token}`)
            .then(r => {
                this.setState({experts: r.data.result});
            })
            .catch(err => {
                config.handleError(err);
            });
    }


    getServices(search = "") {
        axios.get(`${config.api}/admin/service?token=${config.token}&search=${search}`)
            .then(r => {
                this.setState({servicesList: r.data.result});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    handleServiceClick(id) {
        let {services} = this.state;
        let is = false;
        services.map((s, i) => {
            if (s === id) {
                is = true;
                services.splice(i, 1);
            }
        });

        if (!is) {
            services.push(id);
        }

        this.setState({services});
    }

    serviceIsActive(id) {
        const {services} = this.state;
        return services.includes(id);
    }

    submit() {
        const {firstName, lastName, phoneNumber, image, chatId, services} = this.state;
        if (firstName !== "" && lastName !== "" && image && chatId !== "" && services.length > 0) {
            let params = new FormData();
            params.append("firstName", firstName);
            params.append("lastName", lastName);
            params.append("phoneNumber", phoneNumber);
            params.append("image", image);
            params.append("chatId", chatId);
            params.append("services", JSON.stringify(services));

            toast.info("درحال ثبت ...")
            axios.post(`${config.api}/admin/expert?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    toast.success("با موفقیت ثبت شد.");
                    this.setState({
                        firstName: "",
                        lastName: "",
                        image: null,
                        chatId: "",
                        services: [],
                        modalServices: false
                    });
                    this.getExpert();
                })
                .catch(err => {
                    config.handleError(err)
                });

        } else {
            toast.error("همه فیلدها را تکمیل کنید.")
        }
    }

    render() {
        const {
            id,
            experts,
            boxAdd,
            servicesList,
            firstName,
            lastName,
            phoneNumber,
            image,
            chatId,
            services,
            modalServices
        } = this.state;
        return (
            <div className="experts">
                {
                    modalServices ?
                        <Modal
                            onCloseClick={() => this.setState({modalServices: false})}
                            icon="list"
                            title="لیست خدمات"
                            display={modalServices}>
                            <div className="modal-services">
                                {
                                    servicesList.map((s, i) =>
                                        <article key={"service" + i}
                                                 onClick={() => this.handleServiceClick(s.id)}
                                                 className={this.serviceIsActive(s.id) ? "active" : ""}>
                                            <div className="row">
                                                <div className="col-auto">
                                                    <div className="image"><img src={s.image} alt=""/></div>
                                                </div>
                                                <div className="col">
                                                    <p className="title">{s.title}</p>
                                                </div>
                                            </div>
                                        </article>
                                    )
                                }
                            </div>
                        </Modal>
                        : null
                }
                <Back {...this.props}/>
                <div className="row">
                    <div className="col-md-5">
                        <Button submit={false} icon="plus" onClick={() => this.setState({boxAdd: !boxAdd})}>ثبت
                            متخصص</Button>
                    </div>
                </div>

                {boxAdd ?
                    <div className="new">
                        <div className="row">
                            <div className="col-md-6">
                                <Field name="firstName"
                                       value={firstName}
                                       label="نام"
                                       maxLength={100}
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-md-6">
                                <Field name="lastName"
                                       value={lastName}
                                       label="نام خانوادگی"
                                       maxLength={100}
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-md-6">
                                <Field name="phoneNumber"
                                       value={phoneNumber}
                                       label="شماره موبایل"
                                       maxLength={13}
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-md-6">
                                <File name="image"
                                      value={image}
                                      label="عکس پرسنلی"
                                      accept="image/*"
                                      multiple={false}
                                      onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-md-6">
                                <Field
                                    type="number"
                                    name="chatId"
                                    value={chatId}
                                    style={{direction: "ltr"}}
                                    label="آی دی عددی تلگرام"
                                    maxLength={20}
                                    onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-md-12">
                                <Button submit={false}
                                        icon="list"
                                        onClick={() => this.setState({modalServices: true})}>لیست خدمات</Button>
                                <div className="row justify-content-center">
                                    <div className="col-md-5">
                                        <Button submit={false} onClick={() => this.submit()} icon="plus">ثبت
                                            کردن</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

                <br/>
                <div className="list">
                    {experts.map((e, i) =>
                        <article key={"expert" + i}>
                            <div className="row">
                                <div className="col-auto">
                                    <div className="image">
                                        <img src={e.personalPhoto} alt=""/>
                                    </div>
                                </div>
                                <div className="col">
                                    <p className="full-name"><span>{e.firstName}</span>&nbsp;
                                        <span>{e.lastName}</span>&nbsp;<span>({e.phoneNumber})</span>
                                    </p>
                                </div>

                                <div className="col-auto">
                                    <Icon i="edit" className="edit-icon"
                                          onClick={() => this.props.navigate(`/expert/${e.id}`)}/>
                                </div>
                            </div>
                        </article>
                    )}
                </div>
            </div>
        );
    }
}

export default gpn(Experts);